import React from 'react';
import { default as BreadcrumbsUI } from "@hm-group/navigation-ui/Breadcrumbs";
import { trackEvent } from "@pb/utils/tracking";
// NOTE: further direct use of this compoennt should be avoided. Use version directly from navigation-ui instead.
const Breadcrumbs = (props) => {
    const updatedProps = Object.assign(Object.assign({}, (!props.onItemClick && {
        onItemClick: (label) => {
            trackEvent({
                event_type: 'BREADCRUMB_CLICK',
                event_id: 'breadcrumb',
                event_category: 'navigation',
                event_label: label,
            });
        },
    })), props);
    return React.createElement(BreadcrumbsUI, Object.assign({}, updatedProps));
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map